export default "__VITE_ASSET__BUGBir4W__"